import { render, staticRenderFns } from "./MenuItemForm.vue?vue&type=template&id=376bc05d&scoped=true"
import script from "./MenuItemForm.vue?vue&type=script&lang=js"
export * from "./MenuItemForm.vue?vue&type=script&lang=js"
import style0 from "./MenuItemForm.vue?vue&type=style&index=0&id=376bc05d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376bc05d",
  null
  
)

export default component.exports